import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { serviceAuthIcons } from 'app/constants';
import { HTTPService, HelperService, FormatService, DataService } from 'app/services';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-deferred-service-sidelist',
  templateUrl: './deferred-service-sidelist.component.html',
  styleUrls: ['./deferred-service-sidelist.component.scss'],
})
export class DeferredServiceSidelistComponent implements OnInit {
  @Input('totalRecords') 
  set setTotalRecords(totalRecords: number) {
    this.totalRecords = totalRecords;
  }
  @Input('customerId')
  set setCustomerId(customerId: any) {
    if (!customerId) {
      this._vehicles = [];
      this.orders = [];
      this.customer = {};
      this.selectedVehicle = {};
    } else {
      this.getDeferredService(customerId);
    }
  }
  @Input('customerData')
  set customerData(data: any) {
    if (data) {
      this.customer = data;
    }
  }
  @Input('vehicles')
  set vehicles(vehicles: any[]) {
    if (vehicles && vehicles.length > 0) {
      this._vehicles = vehicles;

      this.formatVehicleDataMap(this._vehicles);
      this.defaultVehicles = this._vehicles;
    }
  }
  @Input() isMultiLocationEnabled: boolean = false;
  @Input() shopsMap: any = {};

  defaultVehicles = [];
  isVehiclesLoading = false;
  searchKey = '';
  _vehicles: any = [];
  totalRecords: number = 0;
  isLoadingMore: boolean = false;
  skip: number = 0
  orders: any = [];
  customer: any = {};
  serviceStatus: any = {};
  selectedVehicle: any;
  estimate: any = {
    vehicle: {},
    defaultDeferredService: [],
    customer: {},
  };
  usd: string = currency.USD;
  vehicleDataMap = {};
  serviceAuthIcons = serviceAuthIcons;
  dontShowOnSearch = false;

  constructor(private httpService: HTTPService, private helperService: HelperService, private dialogService: DialogService, private formatService: FormatService, private dataService: DataService) {}

  ngOnInit() {
    this.getDeferredService(this.customer._id);
    // this.defaultVehicles = this.helperService.deepCopy(this.vehicles);
  }

  getDeferredService(customerId: any) {
    this.httpService.getCustomerDeferredService(customerId).then(
      (data) => {
        this.orders = this.formatOrder(data);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  formatOrder(order: any = {}) {
    if (order.services && order.services.length) {
      order.services.forEach((service: any) => {
        this.serviceStatus[service._id] = service.services;
        service.services.forEach((service: any) => {
          if (service.items && service.items.length) {
            service.itemCount = {
              part: 0,
              labor: 0,
              tire: 0,
              other: 0,
            };

            service.items.forEach((item: any) => {
              service.itemCount[item.type] += item.count;
            });

            if (service.serviceAuthHistory && service.serviceAuthHistory.length) {
              service.serviceAuthHistory = this.formatService.formatServiceHistory(service.serviceAuthHistory);
            }
          }
        });
      });
    }
    return order;
  }

  onSelectVehicle(vehicle) {
    this.selectedVehicle = vehicle;
    this.searchKey = vehicle.name;
    this.httpService.getCustomerDeferredService(this.customer._id, this.selectedVehicle._id).then(
      (data) => {
        this.orders = this.formatOrder(data);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onSearchEnter(query) {
    if (!query) {
      return;
    }
    const table = {
      skip: 0,
      search: query,
      needPagination: false,
      fetchTags: false
    }
    this.searchKey = query;
    this.httpService
      .getCustomerVehicle(this.customer._id, table)
      .then(({ vehicles, totalRecords, tags, company }) => {
        this.totalRecords = totalRecords;
        this._vehicles = vehicles;
        this.formatVehicleDataMap(this._vehicles);
      })
      .finally(() => {
        this.isVehiclesLoading = false;
      });
  }

  searchVehicle($event) {
    if($event.trim()) {
      this.dontShowOnSearch = true;
    }
    this.isVehiclesLoading = true;
    const table = {
      skip: 0,
      search: $event.trim(),
      needPagination: false,
      fetchTags: false
    }
    this.httpService
      .getCustomerVehicle(this.customer._id, table)
      .then(({ vehicles, totalRecords, tags, company }) => {
        this._vehicles = vehicles;
        this.totalRecords = totalRecords;
        this.formatVehicleDataMap(this._vehicles);
        // this.defaultVehicles = this.helperService.deepCopy(this.vehicles);
      })
      .finally(() => {
        this.isVehiclesLoading = false;
      });
  }

  clearVehicleFilter() {
    this.dontShowOnSearch = false;
    this.getDeferredService(this.customer._id);
    this.selectedVehicle = '';
    this.searchKey = '';
    this._vehicles = this.defaultVehicles;
    this.formatVehicleDataMap(this._vehicles);
  }

  onScroll(event) {
    this.skip +=20;
    this.isLoadingMore = true;
    const table = {
      skip: this.skip,
      limit: 20,
      needPagination: true,
      fetchTags: false
    }
    this.httpService
      .getCustomerVehicle(this.customer._id, table)
      .then(({ vehicles, totalRecords }) => {
        this.formatVehicleDataMap(vehicles);
        this._vehicles = [...this._vehicles, ...vehicles];
        this.totalRecords = totalRecords;
        
        this.isLoadingMore = false;
        this.defaultVehicles = this.helperService.deepCopy(this._vehicles);
      })
      .finally(() => {
        this.isLoadingMore = false;
      });
  }

  onDeleteDefrred(service, { isTransferActive }) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'Remove the service from deferred services list?',
        message: 'This service will be marked as declined and will be permanently removed from deferred services list.',
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.deleteDeferredService(service);
      }
      onClose.unsubscribe();
    });
  }

  deleteDeferredService(service) {
    this.httpService.deleteCustomerDeferredService(service._id).then(
      (data) => {
        this.getDeferredService(this.customer._id);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onAddRO(service) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: 'Save changes and create New RO with this service',
        button: {
          success: { title: 'Yes' },
          cancel: { title: 'No' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.createRO(service);
      }
      onClose.unsubscribe();
    });
  }

  createRO(service: any) {
    this.estimate.defaultDeferredService = service;
    this.estimate.vehicle = {
      browserSessionId: Date.now(),
      vehicleId: service.estimate.vehicleId,
      name: service.estimate.vehicleName,
    };
    this.estimate.customer = {
      customerId: this.customer._id,
      fullName: this.customer.fullName,
      displayName: this.customer.fullNameQBO,
      companyName: this.customer.companyName,
      isFleetCustomer: this.customer.isFleetCustomer,
      email: this.customer.email,
      phone: this.customer.phone,
      phone2: this.customer.phone2,
      tags: this.customer.tags,
      notes: this.customer.notes,
    };
    this.estimate.title = this.estimate.customer.displayName;
    let hasPartsTechParts = false;
    if (service.items && service.items.length) {
      hasPartsTechParts = !!service.items.filter(({ itemSource }) => itemSource === 'PartsTech').length;
    }
    /** Creating and open estimate in new tab */
    this.httpService.createEstimates(this.estimate).then(
      (order: any) => {
        const queryParams: any = {
          hasPartsTechParts,
          browserSessionToken: order.restriction.token || '',
          checkPreferredLocation: order.checkPreferredLocation || false,
        };

        const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
        // this.isEstimateCreating = false;
        this.helperService.openPageInNewExistingTab(url, order._id);
        if (this.dataService.isGainSightPXEnabled) {
          const estimateCreated: any = {
            roCreationSource: 'Customer side-panel deferred tab',
            roNumber: order.code || '',
          };

          this.helperService.postGainsightPXEvent('RO Created', estimateCreated);
        }
      },
      (err) => {
        // this.isEstimateCreating = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  openEstimate(service: any) {
    this.helperService.openPageInNewExistingTab(`/estimate/${service.estimate.estimateId}`, service.estimate._id);
  }

  formatVehicleDataMap(records) {
    records.forEach((vehicle) => {
      this.vehicleDataMap[vehicle._id] = {
        vin: vehicle.vin,
        isActive: vehicle.isActive,
        licensePlate: vehicle.licensePlateNo || '',
      };
    });
  }
}
